module.exports = __webpack_public_path__ + "img/元素10.ea0151c4.png";